<template>
  <div class="attachments" v-if="enableDocument">
    <div class="dropbox">
      <input
        type="file"
        ref="file"
        name="file"
        @change="onChange"
        accept="*"
        multiple
        v-validate
        data-vv-rules="size:2048100"
      />
      <div class="hint">
        <img
          src="@/assets/UploadFileIcon.svg"
          class="image-icon"
          alt="upload-file"
        />
        <div class="attachments-info">
          <div class="drag-attachment-title">
            {{ $t('post.postFileSelect.attachments') }}
          </div>
          <div v-html="$t('post.postFileSelect.dragAndDropAttachments')"></div>
        </div>
      </div>
    </div>
    <span
      class="validate-message"
      v-if="errors.has('file')"
    >{{ $t('post.postFileSelect.fileSizeValidation') }}</span>
    <div
      v-for="(file, index) in files"
      :key="index"
      class="file-block"
    >
      <img
        src="@/assets/AttachementIcon.svg"
        alt="attachment-icon"
        class="document-icon"
      />
      <div class="document-details">
        <div class="document-name">
          {{ file.name }}
        </div>
        <div class="document-properties">
          {{ readableBytes(file.size) }}
        </div>
      </div>
      <div class="spacer" />
      <img
        src="@/assets/Uncheck.svg"
        @click="onRemoveFile(index)"
        class="delete-icon"
      />
    </div>
  </div>
</template>

<script>
import config from '../../config'

export default {
  name: 'PostFileSelect',
  props: {
    initialFiles: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      files: [],
      enableDocument: config.ENABLE_DOCUMENT
    }
  },
  created () {
    this.initialFiles.forEach(file => {
      this.files.push(file)
    })
  },
  methods: {
    onChange (event) {
      const fileList = event.target.files
      for (let i = 0; i < fileList.length; i++) {
        if (fileList.item(i).size <= 2048000000) {
          this.files.push(fileList.item(i))
        }
      }
      this.$emit('changeFiles', this.files)
    },
    onRemoveFile (index) {
      this.files.splice(index, 1)
      this.$emit('changeFiles', this.files)
    },
    readableBytes (bytes) {
      const i = Math.floor(Math.log(bytes) / Math.log(1024))
      const sizes = [ 'B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB' ]
      return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + sizes[ i ]
    }
  }
}
</script>

<style scoped lang="scss">
.attachments {
    display: flex;
    flex-direction: column;
}

.dropbox {
    height: 80px;
    width: 800px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;

    input {
        box-sizing: border-box;
        opacity: 0;
        width: 800px;
        height: 80px;
        cursor: pointer;
        position: absolute;
        border: solid 1px red;
        z-index: 1;
    }

    .hint {
        border: 4px dashed #D8D8D8;
        border-radius: 3px;
        background: white;
        cursor: pointer;
        box-sizing: border-box;
        height: 80px;
        width: 800px;
        padding-left: 20%;
        display: flex;
        align-items: center;
        justify-content: left;
        color: #2c3e50;

        .attachments-info {
          flex-direction: column;
          font-size: 14px;

          .drag-attachment-title {
            font-weight: bold;
            text-align: left;
            font-size: 16px;
          }

          .blue {
            color: $primary-color
          }

        }

        .image-icon {
            width: 45px;
            height: 37px;
            margin-right: 13px;
        }

        .delete-icon {
            position: absolute;
            top: 28px;
            right: 17px;
        }
    }
}

.dropbox:hover {
    background: #f2f2f2; /* when mouse over to the drop zone, change color */
}

.image-select {
    margin-left: 1.5rem;
    margin-top: 1.5rem;
    width: 395px;
}

.file-block {
    display: flex;
    align-items: center;
    width: 800px;
    height: 44px;
    margin-top: 12px;
    background: #F2F2F2;
    border-radius: 3px;

    .document-icon {
        margin-left: 13px;
        width: 30px;
        height: 34px;
    }

    .document-details {
        margin: 2px 0 0 8px;
        text-align: left;

        .document-name {
            font-family: OpenSans-Bold, sans-serif;
            font-weight: bold;
            font-size: 14px;
            color: $black-color;
            letter-spacing: 0;
            line-height: 21px;
        }

        .document-properties {
            font-family: OpenSans-Regular, sans-serif;
            font-size: 13px;
            color: #999999;
            letter-spacing: 0;
            line-height: 19px;
        }
    }

    .spacer {
        flex-grow: 1;
    }

    .delete-icon {
        margin-right: 18px;
        cursor: pointer;
    }

}

.validate-message {
    color: $cerise-color;
    font-weight: bold;
    display: inline;
    font-size: 14px;
}

</style>
